var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import { omit } from 'lodash';
import ReactGA from 'react-ga4';
import { googleAnalyticsKey } from '../../environment.vars';
var trackEvent = function () {
    ReactGA.event({
        category: 'Release Notes',
        action: "What's new click",
    });
};
export var useGoogleAnalytics = function () {
    var _a = __read(useState(false), 2), initialized = _a[0], setInitialized = _a[1];
    if (!googleAnalyticsKey)
        return null;
    if (!initialized) {
        ReactGA.initialize(googleAnalyticsKey);
        setInitialized(true);
    }
    return __assign(__assign({}, omit(ReactGA, 'initialize', 'event')), { event: trackEvent });
};
//# sourceMappingURL=useGoogleAnalytics.js.map